<template>
  <b-overlay :show="loading">
    <div class="d-flex justify-content-between p-3">
      <b-form inline @submit.prevent="searchBlogs">
        <b-form-input
          v-model="form.query"
          id="form-search"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="Enter text"
        ></b-form-input>
        <b-button variant="primary" type="submit">Search</b-button>
      </b-form>
      <span class="mt-2">Total blogs: {{form.total}}</span>
      <b-pagination class="mb-0"
        v-model="form.page"
        :total-rows="form.total"
        :per-page="form.limit"
        @page-click="changePage"
      ></b-pagination>
    </div>
    <b-table hover :items="blogs" :fields="fields">
      <template #cell(thumb_url)="data">
        <img :src="data.item.thumb_url" style="width: 160px;" alt="">
      </template>
      <template #cell(title)="data">
        {{data.item.title}}
        <br>
        <b-link :href="`/blog/${data.item.url}`" target="_blank">{{`/blog/${data.item.url}`}}</b-link>
      </template>
      <template #cell(actions)="data">
        <b-button :href="`edit/${data.item.id}`" variant="link">Edit</b-button>
        <b-button @click="hideBlog(data.item.id)" variant="link">Hide</b-button>
        <b-button @click="deleteBlog(data.item.id)" variant="link">Delete</b-button>
      </template>
    </b-table>
  </b-overlay>
</template>

<script>
import api from '@/api'

export default {
  data: () => ({
    loading: false,
    form: {
      query: '',
      page: 1,
      limit: 10,
      total: 0
    },
    fields: [
      {
        key: 'id',
        label: 'ID'
      },
      {
        key: 'thumb_url',
        label: 'Thumbnail'
      },
      {
        key: 'title',
        label: 'Title'
      },
      {
        key: 'views_total',
        label: 'Total views'
      },
      {
        key: 'date_published',
        label: 'Published Date'
      },
      {
        key: 'actions',
        label: 'Actions'
      }
    ],
    blogs: []
  }),
  mounted () {
    this.searchBlogs()
  },
  methods: {
    searchBlogs: async function () {
      this.loading = true
      let result = await api.admin.blog.search(this.form.query, this.form.page, this.form.limit)
      this.blogs = result.blogs
      this.form.total = result.total
      this.loading = false
    },
    changePage: function (e, page) {
      if (page !== this.form.page) {
        this.form.page = page
        this.searchBlogs()
      }
    },
    hideBlog: async function (blog_id) {
      let r = await api.admin.blog.setBlogActive(blog_id, false)
      if (r) {
        this.$router.go()
      }
    },
    deleteBlog: async function (blog_id) {
      let r = await api.admin.blog.deleteBlog(blog_id)
      if (r) {
        this.$router.go()
      }
    }
  }
}
</script>

<style scoped>
</style>
